/* assets/tabbed-collections-chati.js */
(function () {
  'use strict';

  const SELECTORS_COUNT = [
    '[data-cart-count]',
    '#CartCount',
    '.header__cart-count',
    '.js-cart-count',
    '.site-header__cart-count',
    '#cart-icon-bubble .cart-count-bubble__count',
    '#cart-icon-bubble .cart-count-bubble span[aria-hidden]',
    '.cart-count-bubble .cart-count-bubble__count',
    '.cart-count-bubble span[aria-hidden]',
    '.cart-link__bubble',
    '.cart-count'
  ];

  /* ---------- Toast ---------- */
  function ensureToast() {
    let t = document.getElementById('tb-global-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'tb-global-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    return t;
  }
  function showToast(message, nearEl) {
    const t = ensureToast();
    t.textContent = message;
    let x = 20, y = 20;
    if (nearEl && nearEl.getBoundingClientRect) {
      const r = nearEl.getBoundingClientRect();
      x = Math.min(window.innerWidth - 232, Math.max(12, r.right + 8));
      y = Math.min(window.innerHeight - 36, Math.max(12, r.top + r.height / 2 - 12));
    }
    t.style.left = x + 'px';
    t.style.top = y + 'px';
    t.classList.add('is-show');
    clearTimeout(t._hideTimer);
    t._hideTimer = setTimeout(() => t.classList.remove('is-show'), 1500);
  }

  /* ---------- Cart Count ---------- */
  async function refreshCartCount() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' });
      const cart = await res.json();
      const count = cart.item_count || 0;

      document.querySelectorAll(SELECTORS_COUNT.join(',')).forEach(el => {
        if (el.classList.contains('cart-count-bubble') || el.closest('.cart-count-bubble')) {
          const bubble = el.classList.contains('cart-count-bubble') ? el : el.closest('.cart-count-bubble');
          const inner = bubble.querySelector('.cart-count-bubble__count, span[aria-hidden]');
          if (inner) inner.textContent = count;
          bubble.classList.toggle('hidden', count === 0);
        } else {
          el.textContent = count;
          el.classList.toggle('is-empty', count === 0);
        }
      });

      document.body.dispatchEvent(new CustomEvent('tb:cart:updated', { detail: cart }));
      return cart;
    } catch (e) {
      console.warn('Cart count update failed', e);
    }
  }

  /* ---------- Quick Add (AJAX) ---------- */
  async function addToCart(variantId, qty = 1) {
    const payload = { id: variantId, quantity: qty };
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload),
      credentials: 'same-origin'
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      const msg = err && err.description ? err.description : 'Konnte nicht hinzugefügt werden.';
      throw new Error(msg);
    }
    return res.json();
  }

  // Delegated submit handler (Quick Add)
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.tb-quick-add');
    if (!form) return;

    e.preventDefault();
    const btn = form.querySelector('.tb-quick-add__btn') || form.querySelector('button[type="submit"]');
    const idInput = form.querySelector('input[name="id"]');
    const qtyInput = form.querySelector('input[name="quantity"]');
    const variantId = idInput && idInput.value;
    const qty = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;

    if (!variantId) return;

    btn && btn.setAttribute('disabled', 'disabled');
    btn && btn.classList.add('is-loading');

    try {
      const item = await addToCart(variantId, qty);
      const card = form.closest('.product-card');
      const title = (card && card.getAttribute('data-alpha')) || (item && item.title) || 'Produkt';
      showToast(`„${title}“ zum Warenkorb hinzugefügt`, btn);
      btn && btn.classList.add('is-added');
      setTimeout(() => btn && btn.classList.remove('is-added'), 800);
      await refreshCartCount();
    } catch (err) {
      showToast(String(err.message || err), btn);
      console.warn(err);
    } finally {
      btn && btn.removeAttribute('disabled');
      btn && btn.classList.remove('is-loading');
    }
  });

  /* ---------- Swatches: Bildwechsel + Variante + Hover-Quelle setzen ---------- */
  document.addEventListener('click', (e) => {
    const sw = e.target.closest('.tb-swatch');
    if (!sw) return;

    e.preventDefault();
    const card = sw.closest('.product-card');
    if (!card) return;

    // aktive Klasse
    card.querySelectorAll('.tb-swatch.is-active').forEach(a => a.classList.remove('is-active'));
    sw.classList.add('is-active');

    // Produktbild austauschen (neues Mainbild merken)
    const imgUrl = sw.getAttribute('data-image');
    const img = card.querySelector('img');
    if (imgUrl && img) {
      img.src = imgUrl;
      img.removeAttribute('srcset');
      const pic = img.closest('picture');
      if (pic) { pic.querySelectorAll('source').forEach(s => { s.srcset = imgUrl; }); }
      img.dataset.main = imgUrl;
    }

    // Quick-Add auf gewählte Variante umstellen
    const vId = sw.getAttribute('data-variant');
    const idInput = card.querySelector('.tb-quick-add input[name="id"]');
    if (vId && idInput) idInput.value = vId;

    // Varianten-Hoverquelle aus Swatch übernehmen bzw. bewusst entfernen
    const vHover = sw.getAttribute('data-hover');
    if (vHover) {
      card.setAttribute('data-hover', vHover);
    } else {
      card.removeAttribute('data-hover');
    }

    reflowSoon(); // nach Variantenswitch neu ausrichten
  });

  /* ---------- Hover-Bild (nur über Bildbereich, pro aktive Variante) ---------- */
  function bindHoverSwap() {
    document.querySelectorAll('.tabbed-collections .product-card').forEach(card => {
      if (card.__tbHoverBound) return;
      card.__tbHoverBound = true;

      const img = card.querySelector('img');
      if (!img) return;

      const imgWrap =
        card.querySelector(
          '.card__media, .product__media, .product__image, .product__image-wrapper, .media, .media__image, a[href*="/products/"]'
        ) || img.closest('a') || img.parentElement;

      if (!img.dataset.main) img.dataset.main = img.currentSrc || img.src;

      function currentHoverUrl() {
        const active = card.querySelector('.tb-swatch.is-active[data-hover]');
        if (active) return active.getAttribute('data-hover') || '';
        return card.getAttribute('data-hover') || '';
      }

      function swapTo(url) {
        if (!url) return;
        const current = img.currentSrc || img.src;
        if (current === url) return;
        img.src = url;
        img.removeAttribute('srcset');
        const pic = img.closest('picture');
        if (pic) pic.querySelectorAll('source').forEach(s => { s.srcset = url; });
      }

      function restoreMain() {
        const main = img.dataset.main;
        if (!main) return;
        const current = img.currentSrc || img.src;
        if (current === main) return;
        img.src = main;
        img.removeAttribute('srcset');
        const pic = img.closest('picture');
        if (pic) pic.querySelectorAll('source').forEach(s => { s.srcset = main; });
      }

      if (imgWrap) {
        imgWrap.addEventListener('pointerenter', () => {
          const url = currentHoverUrl();
          if (url) swapTo(url);
        }, { passive: true });
        imgWrap.addEventListener('pointerleave', () => {
          restoreMain();
        }, { passive: true });
      }
    });
  }

  /* ---------- Flickity-kompatible Filter-Helfer ---------- */
  function getCells(scope){
    // alle Produkt-Zellen im aktuellen Tab (funktioniert mit/ohne Carousel und inkl. Clones)
    return (scope || document).querySelectorAll(
      '.tabbed__collection-content .featured__collection-product[data-product-id]'
    );
  }
  function showAllInScope(scope){
    getCells(scope).forEach(c => { c.style.display = ''; });
    pokeFlickity(scope);
  }
  function applyFilter(scope, value){
    const val = (value || 'all');
    const cells = getCells(scope);
    if (val === 'all'){
      showAllInScope(scope);
      return;
    }
    cells.forEach(cell => {
      const groups = (cell.getAttribute('data-groups') || '')
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);
      const match = groups.includes(val);
      cell.style.display = match ? '' : 'none';
    });
    pokeFlickity(scope);
  }
  function pokeFlickity(scope){
    const car = (scope || document).querySelector('.featured__collection-carousel');
    if (!car) return;
    // Versuche, die Flickity-Instanz zu finden und zu aktualisieren
    const flkty = (window.Flickity && window.Flickity.data) ? window.Flickity.data(car) : null;
    if (flkty && flkty.reloadCells) {
      try { flkty.reloadCells(); flkty.resize(); } catch(e){}
    } else {
      // Fallback: Reflow triggern
      window.dispatchEvent(new Event('resize'));
    }
  }

  /* ---------- Subfilter (3 Farb-Swatches) – robust & mit Reset ---------- */
  function bindSubfilters() {
    document.querySelectorAll('.tb-subfilters').forEach(bar => {
      if (bar.__tbBound) return;
      bar.__tbBound = true;

      const scope = bar.closest('.tabbed__collection-content') || document;

      // Initial: wenn kein Button aktiv → alles zeigen (Reset)
      if (!bar.querySelector('.tb-subfilter.is-active')) {
        showAllInScope(scope);
      }

      bar.addEventListener('click', (e) => {
        const btn = e.target.closest('.tb-subfilter'); if (!btn) return;

        // aktive Markierung umschalten
        const wasActive = btn.classList.contains('is-active');
        bar.querySelectorAll('.tb-subfilter.is-active').forEach(b => b.classList.remove('is-active'));
        const filterVal = wasActive ? 'all' : (btn.getAttribute('data-filter') || 'all');
        if (!wasActive) btn.classList.add('is-active');

        // immer erst resetten, dann filtern
        showAllInScope(scope);
        applyFilter(scope, filterVal);

        reflowSoon(); // Warenkorb-Button neu ausrichten
      });
    });
  }

  /* ---------- Cart-Button bündig mit Preis/Titel ---------- */
  function isHidden(el){
    return !el || (!el.offsetParent && getComputedStyle(el).display === 'none');
  }

  function positionQuickAdd() {
    const PRICE_SEL = '.price, .product__price, .card-information__meta, .price__container, .price__regular, [data-product-price], .product-item__price';
    const TITLE_SEL = '.product__title, .product-title, .prod-title, .card-information__text, .product-info__caption, h3 a[href*="/products/"], h3, [data-alpha]';

    document.querySelectorAll('.tabbed-collections .product-card').forEach(card => {
      const btnWrap = card.querySelector('.tb-quick-add');
      if (!btnWrap) return;

      const tab = card.closest('.tabbed__collection-content');
      if (isHidden(tab)) return;

      const anchor = card.querySelector(PRICE_SEL) || card.querySelector(TITLE_SEL);
      const cardRect = card.getBoundingClientRect();
      let top = 8;

      if (anchor) {
        const a = anchor.getBoundingClientRect();
        const btnH = 40;
        top = (a.top - cardRect.top) + (a.height - btnH) / 2;
      }
      btnWrap.style.top = Math.max(8, Math.round(top)) + 'px';
    });
  }

  /* ---------- Reflow-Helfer (entprellt) ---------- */
  let reflowTimer = null;
  function reflowSoon(delay = 120){
    clearTimeout(reflowTimer);
    reflowTimer = setTimeout(() => { positionQuickAdd(); }, delay);
  }

  // Initial / Resize / Section Events
  document.addEventListener('DOMContentLoaded', () => {
    // globaler Reset: in allen Tabs ohne aktiven Subfilter alles sichtbar
    document.querySelectorAll('.tabbed__collection-content').forEach(scope => {
      const bar = scope.querySelector('.tb-subfilters');
      if (bar && !bar.querySelector('.tb-subfilter.is-active')) showAllInScope(scope);
    });

    positionQuickAdd();
    bindHoverSwap();
    bindSubfilters();
    refreshCartCount();
  });

  window.addEventListener('resize', () => reflowSoon(40));

  document.addEventListener('shopify:section:load', (e) => {
    const scope = e.target || document;
    const bar = scope.querySelector && scope.querySelector('.tb-subfilters');
    if (bar && !bar.querySelector('.tb-subfilter.is-active')) showAllInScope(scope);
    pokeFlickity(scope);
    reflowSoon(80); bindHoverSwap(); bindSubfilters();
  });

  document.addEventListener('shopify:section:select', (e) => {
    const scope = e.target || document;
    const bar = scope.querySelector && scope.querySelector('.tb-subfilters');
    if (bar && !bar.querySelector('.tb-subfilter.is-active')) showAllInScope(scope);
    pokeFlickity(scope);
    reflowSoon(80); bindHoverSwap(); bindSubfilters();
  });

  // Tab-Klick → nach Sichtbarwerden: Reset (falls kein aktiver Filter) + Flickity + Reflow
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('.js-tab-trigger');
    if (!tab) return;
    const ref = tab.getAttribute('href') || tab.getAttribute('data-content');
    setTimeout(() => {
      const scope = document.querySelector(ref && ref.startsWith('#') ? ref : `#${ref}`);
      if (scope) {
        const bar = scope.querySelector('.tb-subfilters');
        if (bar && !bar.querySelector('.tb-subfilter.is-active')) showAllInScope(scope);
        pokeFlickity(scope);
      }
      reflowSoon(180);
    }, 80);
  });

  // Bilder fertig? → neu ausrichten
  document.addEventListener('load', (e) => {
    if (e.target && e.target.tagName === 'IMG' && e.target.closest('.tabbed-collections')) {
      reflowSoon(20);
    }
  }, true);

  // Sichtbarkeitsänderungen beobachten
  const tabsRoot = document.querySelector('.tabbed-collections');
  if (tabsRoot && 'MutationObserver' in window) {
    const mo = new MutationObserver(() => reflowSoon(120));
    mo.observe(tabsRoot, { attributes: true, subtree: true, attributeFilter: ['class', 'style', 'hidden'] });
  }

  // Fallback
  setTimeout(() => { positionQuickAdd(); }, 400);

})();









